<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">
		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Descrição:</label>
			<div class="col-sm-10">
				<input type="text"
						name="descricao"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('descricao')}"
						v-model="form.descricao"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Tipo:</label>
			<div class="col-sm-10">
				<select v-model="form.tipo"
						name="tipo"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('tipo')}"
						class="form-control form-control-sm">
						<option value="">Escolha</option>
						<option value="Produção">Produção</option>
						<option value="Homologação">Homologação</option>
						<option value="Teste">Teste</option>
				</select>
				<span  class="invalid-feedback" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</span>
			</div>
		</div>

		<h5>URL's de Envio</h5>
		<hr>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Posição:</label>
			<div class="col-sm-10">
				<input type="text"
						name="posição"
						v-validate="'required|url'"
						:class="{'is-invalid' : errors.has('posição')}"
						v-model="form.urlPosicao"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('posição')">{{ errors.first('posição') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Trecho:</label>
			<div class="col-sm-10">
				<input type="text"
						name="trecho"
						v-validate="'required|url'"
						:class="{'is-invalid' : errors.has('trecho')}"
						v-model="form.urlTrecho"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('trecho')">{{ errors.first('trecho') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Mensagem:</label>
			<div class="col-sm-10">
				<input type="text"
						name="mensagem"
						v-validate="'required|url'"
						:class="{'is-invalid' : errors.has('mensagem')}"
						v-model="form.urlMensagem"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('mensagem')">{{ errors.first('mensagem') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Manutenção:</label>
			<div class="col-sm-10">
				<input type="text"
						name="manutencao"
						v-validate="'url'"
						:class="{'is-invalid' : errors.has('manutencao')}"
						v-model="form.urlManutencao"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('manutencao')">{{ errors.first('manutencao') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Abastecimento:</label>
			<div class="col-sm-10">
				<input type="text"
						name="abastecimento"
						v-validate="'url'"
						:class="{'is-invalid' : errors.has('abastecimento')}"
						v-model="form.urlAbastecimento"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('abastecimento')">{{ errors.first('abastecimento') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm"></label>
			<div class="col-sm-6">
				<toggle-button
							v-model="form.ativo"
							:width="110"
							:height="30"
							:sync="true"
							:value="form.ativo"
							:labels="{checked: 'ATIVO', unchecked: 'DESATIVADO'}"
							:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
			</div>
		</div>

		<hr />

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<script>
import axios from '../../routers/axios'
export default {

    data(){
        return {

            tiposServicos: [],
            form: {
                id: 0,
                descricao: "",
                urlPosicao: "",
                urlMensagem: "",
				urlTrecho: "",
				urlManutencao: "",
				urlAbastecimento: "",
                tipo: "",
                ativo: false,

            }
        }
    },

    mounted () {
        axios.get(this._getUrl('api/tiposervico')).then(response => {
            if(response.status == 200){
                this.tiposServicos = response.data
            }
        })
    },

    methods: {

        editar (item){
            this.form.id = item.id
            this.form.descricao = item.descricao
            this.form.urlMensagem = item.urlMensagem
            this.form.urlPosicao = item.urlPosicao
			this.form.urlTrecho = item.urlTrecho
			this.form.urlManutencao = item.urlManutencao
			this.form.urlAbastecimento = item.urlAbastecimento
            this.form.tipo = item.tipo
            this.form.ativo = item.ativo
        },

        onChangeEventHandler(value){
            //console.log(value)
            this.form.ativo = value.value
        },

        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.salva();
                }
            });
        },

        salva(){
            var data = {
                id: this.form.id,
                descricao: this.form.descricao,
                urlPosicao: this.form.urlPosicao,
				urlTrecho: this.form.urlTrecho,
				urlMensagem: this.form.urlMensagem,
				urlManutencao: this.form.urlManutencao,
				urlAbastecimento: this.form.urlAbastecimento,
                ativo: this.form.ativo,
                tipo:  this.form.tipo,
            }

            this.$notify.loadIn('Salvando')

            if(this.form.id != 0){

                axios.put(this._getUrl('api/servidorenvio') + '/' + this.form.id, data).then(response => {
                    this.$emit('item-salvo', response.data)
                })

            } else {

                axios.post(this._getUrl('api/servidorenvio'), data).then(response => {
                    this.$emit('item-salvo', response.data)
                    this.form.id = response.data.id
                })
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/servidor-envio/cadastro.vue